import { SearchInputStore } from 'ui/standard/input/search_input/search_input_store';

export class LocaleSelectorStore {
  search: SearchInputStore;

  constructor() {
    this.search = new SearchInputStore();
  }
}
